import DailyStatsChart from './DailyStatsChart';

export default DailyStatsChart;
